<template>
  <div class="CustomCurve lxn-w100 lxn-h100">
    <div class="CustomCurve-d1 lxn-w100 lxn-pos-rel">
      <slot></slot>
    </div>
    <div class="CustomCurve-svg-wrapper lxn-w100 lxn-pos-rel">
      <div class="CustomCurve-curve lxn-pos-abs">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomCurve',
  props: {
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .CustomCurve {
    background-color: transparent;
  }
  .CustomCurve-d1 {
    height: calc(100% - 50px);
    z-index: 2;
  }
  .CustomCurve-curve {
    top: calc(50px - 1200px);
    left: calc(50vw - 600px);
    width: 1200px;
    height: 1200px;
    border-radius: 50%;
    background-color: #1EA5DE;
  }
  .CustomCurve-svg-wrapper {
    top: 0;
    left: calc(50% - 50vw);
    width: 100vw;
    height: 50px;
  }
  .CustomCurve-svg .st0 {
    fill: #1EA5DE;
  }
</style>
